<template>
    <div :style="{'height':clientHeight-90+'px'}">
        <div >
            <div class="m-portlet m-b-10" :style="{'height':100+'px'}">
                <div class="m-portlet__body">
                    <el-form label-position="right" label-width="90px">
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-form-item label="类型">
                                    <el-select v-model="filter.type_id" clearable placeholder="请选择类型" filterable remote
                                               @change="handleChange()"
                                               style="width: 200px">
                                        <el-option
                                                v-for="item in type"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="学期">
                                    <el-select v-model="filter.semester_ids" placeholder="请选择学期" multiple
                                               clearable
                                               @change="handleChange()"
                                               style="width: 200px">
                                        <el-option
                                                v-for="item in semesters"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="期数">
                                    <el-select v-model="filter.sort" clearable placeholder="请选期数" filterable remote
                                               @change="handleChange()"
                                               style="width: 200px">
                                        <el-option
                                                v-for="item in sorts"
                                                :key="item.sort"
                                                :label="item.date"
                                                :value="item.sort">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="对比期数">
                                    <el-select v-model="filter.contrast_sort" clearable placeholder="请选择对比期数" filterable remote
                                               @change="handleContrastFinancialInvoicePanel()"
                                               style="width: 200px">
                                        <el-option
                                                v-for="item in sorts"
                                                :key="item.sort"
                                                :label="item.date"
                                                :value="item.sort">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
                <div :style="{'height':(clientHeight-200)+'px'}">
                    <div class="m-portlet m-b-10" v-if="powers.includes(80) && Object.keys(sum_invoiceClassPanels).length>0">
                        <div class="m-portlet__body" v-loading="loading" :style="{'height':200+sum_height+'px'}" @click="heightChange('sum')">
                            <div style="font-size: 15px;height: 20px" v-if="sorts[filter.sort]">{{sorts[filter.sort].date}}汇总</div>
                            <el-table  v-if="!loading"
                                    :data="sum_invoiceClassPanels"
                                    style="width: 100%"
                                    :height="150+sum_height"
                                    size="middle">
                                <el-table-column prop="type_name" label="类型"></el-table-column>
                                <el-table-column  label="始收">
                                    <template slot-scope="scope">
                                        {{scope.row.sum_price|currency('￥',2)}}
                                    </template>
                                </el-table-column>
                                <el-table-column  label="预收">
                                    <template slot-scope="scope">
                                        {{scope.row.sum_advance|currency('￥',2)}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="sum_income" label="收入">
                                    <template slot-scope="scope">
                                        {{scope.row.sum_income|currency('￥',2)}}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="m-portlet m-b-10" v-if="powers.includes(80) && Object.keys(contrast_invoiceClassPanels).length>0">
                        <div class="m-portlet__body" v-loading="loading" :style="{'height':200+contrast_height+'px'}" @click="heightChange('contrast')">
                            <div style="font-size: 15px;height: 20px" v-if="sorts[filter.contrast_sort] && sorts[filter.sort]">{{sorts[filter.contrast_sort].date}}对比{{sorts[filter.sort].date}}</div>
                            <el-table  v-if="!loading"
                                       :data="contrast_invoiceClassPanels"
                                       style="width: 100%"
                                       :height="150+contrast_height"
                                       size="middle">
                                <el-table-column prop="type_name" label="类型"></el-table-column>
                                <el-table-column   label="始收">
                                    <template slot-scope="scope">
                                        {{scope.row.sum_price|currency('￥',2)}}
                                    </template>
                                </el-table-column>
                                <el-table-column   label="预收">
                                    <template slot-scope="scope">
                                        {{scope.row.sum_advance|currency('￥',2)}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="收入">
                                    <template slot-scope="scope">
                                        {{scope.row.sum_income|currency('￥',2)}}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="m-portlet m-b-10">
                        <div class="m-portlet__body" :style="{'height':clientHeight-300-classListHeight+list_height+'px'}" @click="heightChange('list')">
                            <el-table v-if="!loading"
                                      :data="invoiceClassPanels"
                                      style="width: 100%"
                                      :height="clientHeight-330-classListHeight+list_height"
                                      size="middle">
                                <el-table-column prop="invoice_id" label="合同编号"></el-table-column>
                                <el-table-column prop="student_name" label="学生"></el-table-column>
                                <el-table-column prop="class_id" label="班级编号"></el-table-column>
                                <el-table-column prop="class_name" label="班级"></el-table-column>
                                <el-table-column prop="section_name" label="校区"></el-table-column>
                                <el-table-column prop="semester_name" label="学期"></el-table-column>
                                <el-table-column prop="teacher_name" label="老师"></el-table-column>
                                <el-table-column prop="class_type_name" label="班型"></el-table-column>
                                <el-table-column prop="grade_name" label="年级"></el-table-column>
                                <el-table-column prop="subject_name" label="学科"></el-table-column>
                                <el-table-column label="始收">
                                    <template slot-scope="scope">
                                        {{scope.row.price|currency('￥',2)}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="预收">
                                    <template slot-scope="scope">
                                      {{scope.row.advance|currency('￥',2)}}
                                    </template>
                                </el-table-column>
                                <el-table-column  label="收入">
                                    <template slot-scope="scope">
                                        {{scope.row.income|currency('￥',2)}}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="m-portlet__foot">
                            <!--分页-->
                            <div class="text-center">
                                <el-pagination
                                        @size-change="handleSizeChange"
                                        @current-change="handleCurrentChange"
                                        :current-page="currentPage"
                                        :page-sizes="[10, 20, 50, 100]"
                                        :page-size="10"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="total">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'FinancialInvoice-list',
        data() {
            return {
                path: "/financial/panel",
                loading: true,
                sorts:[],
                type:[
                    {
                        id:1,
                        name:'校区'
                    },
                    {
                        id:2,
                        name:'学期'
                    },
                    {
                        id:3,
                        name:'老师'
                    },
                    {
                        id:4,
                        name:'年级'
                    },
                    {
                        id:5,
                        name:'学科'
                    },

                ],
                sum_invoiceClassPanels:[],
                invoiceClassPanels:[],
                contrast_invoiceClassPanels:[],
                filter:{
                    type_id:'',
                    sort:'',
                    contrast_sort:'',
                    semester_ids:[]
                },
                currentPage: 1,
                currentPageSize: 10,
                total:0,
                sum_height:0,
                contrast_height:0,
                list_height:0,
                semesters:[]
            }
        },
        created() {
            this.handleCreate();
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            classListHeight(){
                var  height=0;
                if(Object.keys(this.sum_invoiceClassPanels).length>0){
                    height=height+200;
                }
                if(Object.keys(this.contrast_invoiceClassPanels).length>0){
                    height=height+200;
                }
                return height;
            }
        },
        methods: {
            heightChange(type){
                if(type=='sum'){
                    this.sum_height=300;
                    if(Object.keys(this.contrast_invoiceClassPanels).length>0){
                        this.contrast_height=-100;
                        this.list_height=-200;
                    }else{
                        this.contrast_height=0;
                        this.list_height=-300;
                    }

                }else if(type=='contrast'){
                    if(Object.keys(this.sum_invoiceClassPanels).length>0){
                        this.sum_height=-100;
                        this.list_height=-200;
                    }else{
                        this.sum_height=0;
                        this.list_height=-300;
                    }
                    this.contrast_height=300;
                }else if(type=='list'){
                    this.list_height=0;
                    if(Object.keys(this.contrast_invoiceClassPanels).length>0){
                        this.contrast_height=-150;
                        this.list_height+=150;
                    }
                    if(Object.keys(this.sum_invoiceClassPanels).length>0){
                        this.sum_height=-150;
                        this.list_height+=150;
                    }
                }
            },
            handleCreate() {
                //建立webSocket链接
                this.$wApi.addListen(this.path, this.handleData);
                this.$wApi.send(this.path, 'financial_class_init');
            },
            handleData(event, data) {
                switch (event) {
                    case 'financial_class_init':
                        this.sorts=data.sorts
                        this.semesters=data.semesters
                        this.filter.sort=data.sort;
                        this.handleFinancialInvoicePanel();
                        break;
                    case 'financial_class_panel':
                        this.sum_invoiceClassPanels=data.sum_invoiceClassPanels
                        this.invoiceClassPanels=data.invoiceClassPanels
                        this.total=data.total
                        this.loading = false;
                        break;
                    case 'contrast_financial_class_panel':
                        this.contrast_invoiceClassPanels=data.contrast_classPanels
                        this.loading = false;
                        break;
                }
            },
            handleFinancialInvoicePanel(currentPage=1){
                if (currentPage===1){
                    this.currentPage=1
                }
                this.$wApi.send(this.path, 'financial_class_panel', {
                    'currentPage': currentPage,
                    'currentPageSize': this.currentPageSize,
                    'filter':this.filter
                });
            },
            handleChange(){
                this.handleFinancialInvoicePanel();
                this.handleContrastFinancialInvoicePanel();
            },
            handleContrastFinancialInvoicePanel(){
                this.loading = true;
                this.$wApi.send(this.path, 'contrast_financial_class_panel', {
                    'filter':this.filter
                });
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleFinancialInvoicePanel(this.currentPage)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleFinancialInvoicePanel(this.currentPage)
            },

        }
    }
</script>
